import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { CreateProfileFormValues } from '../../domain/ProfileTypes';
import { PROFILE_MODAL_STYLES } from '../styles/profileModalStyles';

interface ProfileRadioCardProps {
  register: UseFormRegister<CreateProfileFormValues>;
  value: string;
  label: string;
  description: React.ReactNode;
  checked: boolean;
  disabled?: boolean;
}

export const ProfileRadioCard: React.FC<ProfileRadioCardProps> = ({ 
  register, 
  value, 
  label, 
  description, 
  checked, 
  disabled = false 
}) => (
  <label style={PROFILE_MODAL_STYLES.radioCard.container(checked, disabled)}>
    <input
      {...register('rolName')}
      value={value}
      defaultChecked={checked}
      type="radio"
      disabled={disabled}
      style={PROFILE_MODAL_STYLES.radioCard.input}
    />
    <div style={{ ...PROFILE_MODAL_STYLES.radioCard.header(checked), fontSize: '16px', fontWeight: 700 }}>
      {label}
    </div>
    <div style={PROFILE_MODAL_STYLES.radioCard.content}>
      {description}
    </div>
  </label>
);
